<template>
  <div id="app_s">
    <div id="index" ref="appRef">
      <div class="bg">
        <dv-loading v-if="loading">Loading...</dv-loading>
        <div v-else class="host-body">
          <!-- 第一行 -->
          <div class="d-flex jc-center">
            <dv-decoration-2 class="dv-dec-10" />
            <div class="d-flex jc-center">
              <dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
              <div class="title">
                <span class="title-text">业务运营看板</span>
                <dv-decoration-6
                  class="dv-dec-6"
                  :reverse="true"
                  :color="['#50e3c2', '#67a1e5']"
                />
              </div>
              <dv-decoration-8
                class="dv-dec-8"
                :reverse="true"
                :color="decorationColor"
              />
            </div>
            <dv-decoration-2 class="dv-dec-10-s" />
          </div>
          <!-- 第二行 -->
          <div class="d-flex jc-between px-2">
            <div class="d-flex aside-width">
              <div class="react-left ml-4 react-l-s">
                <span class="react-left"></span>
                <span class="text"></span>
              </div>
              <div class="react-left ml-3">
                <span class="text">数据分析2</span>
              </div>
            </div>
            <div class="d-flex aside-width">
              <div class="react-right bg-color-blue mr-3">
                <span class="text fw-b">EASTCOM</span>
              </div>
              <div class="react-right mr-4 react-l-s">
                <el-button class="react-after" @click="screenout"
                  >退 出</el-button
                >
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="parent">
            <div class="div1">
              <dv-border-box-12>
                <LeftTop/>
              </dv-border-box-12>
            </div>
            <div class="div2">
              <dv-border-box-12>
                <LeftCenter/>
              </dv-border-box-12>
            </div>
            <!-- <div class="div3">
              <dv-border-box-13>
                <LeftBottom/>
              </dv-border-box-13>
            </div> -->
            <div class="div4">
              <dv-border-box-12>
                <RightTop/>
              </dv-border-box-12>
            </div>
            <div class="div5">
              <dv-border-box-12>
                <RightCenter/>
              </dv-border-box-12>
            </div>
            <div class="div6">
              <dv-border-box-13>
                <RightBottom/>
              </dv-border-box-13>
            </div>
            <div class="div7">
              <CenterTop/>
            </div>
            <div class="div8">
              <dv-border-box-12>
                <CenterBottom/>
              </dv-border-box-12>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../../common/utils/drawMixin";
import LeftTop from './LeftTop.vue'
import LeftCenter from './LeftCenter.vue'
// import LeftBottom from './LeftBottom.vue'
import RightTop from './RightTop.vue'
import RightCenter from './RightCenter.vue'
import RightBottom from './RightBottom.vue'
import CenterTop from './CenterTop.vue'
import CenterBottom from './CenterBottom.vue'
export default {
  mixins: [drawMixin],
  components: {
    LeftTop,
    LeftCenter,
    // LeftBottom,
    RightTop,
    RightCenter,
    RightBottom,
    CenterTop,
    CenterBottom
  },
  data() {
    return {
      loading: true,
      decorationColor: ["#568aea", "#000000"]
    };
  },
  methods: {
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    screenout() {
      this.$router.push("/homeIndex");
    }
  },
  mounted() {
    this.cancelLoading();
  }
};
</script>

<style lang="scss" scoped>
#app_s {
  width: 100vw;
  height: 100vh;
  background-color: #020308;
  overflow: hidden;
}
@import "../../assets/screen/index.scss";
</style>



// WEBPACK FOOTER //
// src/views/screen/index.vue